import { render, staticRenderFns } from "./FreightOrder.vue?vue&type=template&id=9e920518&"
import script from "./FreightOrder.vue?vue&type=script&lang=js&"
export * from "./FreightOrder.vue?vue&type=script&lang=js&"
import style0 from "./FreightOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports